import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconUnderline: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconUnderline"><Path d="M5.5 20.5H18.5" stroke="currentColor" strokeLinecap="square"/><Path d="M6.5 3.5V12.0345C6.5 15.6053 8.96243 18.5 12 18.5C15.0376 18.5 17.5 15.6053 17.5 12.0345V3.5" stroke="currentColor" strokeLinecap="square"/></CentralIconBase>;
});

export default IconUnderline;
